import {
	useBlockProps,
	useInnerBlocksProps,
	BlockControls,
	__experimentalUseBlockPreview as useBlockPreview,
} from '@wordpress/block-editor';
import { ToolbarGroup, ToolbarButton } from '@wordpress/components';
import { useSelect } from '@wordpress/data';
import { useState, useMemo } from '@wordpress/element';
import { __ } from '@wordpress/i18n';

import AllInspectorSettings from './InspectorControls';

import '../style.scss';

const SPEED_MAP = {
	slow: '40s',
	medium: '25s',
	fast: '12s',
	'very-fast': '4s',
};

const DEFAULT_TEMPLATE = [
	[ 'core/image', { width: '120px' } ],
	[ 'core/image', { width: '120px' } ],
	[ 'core/image', { width: '120px' } ],
];

export default function Edit( props ) {
	const { attributes, clientId } = props;
	const { direction, speed, gap, startOffscreen, infinite } = attributes;
	const [ isPreview, setIsPreview ] = useState( false );

	const copies = infinite ? 4 : 2;
	const offset = `calc(-100% / ${ copies })`;

	const innerBlocks = useSelect(
		( select ) => select( 'core/block-editor' ).getBlocks( clientId ),
		[ clientId ]
	);

	const editorStyles = useMemo( () => {
		let from, to;
		if ( direction === 'left' ) {
			from = startOffscreen ? '100vw' : '0px';
			to = offset;
		} else {
			from = startOffscreen
				? `calc(${ offset } - 100vw)`
				: offset;
			to = startOffscreen ? '100vw' : '0px';
		}

		return {
			'--brandy-scrolling-gap': gap ?? '24px',
			'--brandy-scrolling-duration': SPEED_MAP[ speed ] ?? '20s',
			'--brandy-scrolling-from': from,
			'--brandy-scrolling-to': to,
		};
	}, [ gap, speed, direction, startOffscreen, offset ] );

	const blockProps = useBlockProps( {
		className: 'brandy-scrolling-wrapper',
		style: editorStyles,
	} );

	const innerBlocksProps = useInnerBlocksProps(
		{ className: 'brandy-scrolling__editor-grid' },
		{
			template: DEFAULT_TEMPLATE,
			templateLock: false,
		}
	);

	// Build duplicated preview content from inner blocks.
	const previewBlocks = useMemo( () => {
		if ( ! innerBlocks.length ) {
			return [];
		}
		if ( infinite ) {
			return [ ...innerBlocks, ...innerBlocks, ...innerBlocks, ...innerBlocks ];
		}
		return innerBlocks
	}, [ innerBlocks, infinite ] );

	const previewRef = useBlockPreview( {
		blocks: previewBlocks,
		props: {
			className: 'brandy-scrolling__group',
		},
	} );

	return (
		<>
			<BlockControls>
				<ToolbarGroup>
					<ToolbarButton
						icon={ isPreview ? 'edit' : 'controls-play' }
						label={
							isPreview
								? __( 'Edit', 'brandy-blocks' )
								: __( 'Preview', 'brandy-blocks' )
						}
						onClick={ () => setIsPreview( ! isPreview ) }
						isPressed={ isPreview }
					/>
				</ToolbarGroup>
			</BlockControls>
			<AllInspectorSettings { ...props } />
			<div { ...blockProps }>
				{ isPreview ? (
					<div className="brandy-scrolling__preview">
						<div className="brandy-scrolling__preview-track ">
							<div { ...previewRef } />
						</div>
					</div>
				) : (
					<div { ...innerBlocksProps } />
				) }
			</div>
		</>
	);
}
